<template>
    <modal :show="show">
        <div slot="modalHeader">
          <modal-header :closeModal="close">Add Client To {{ name }}</modal-header>
        </div>
        <list v-model="clientsInEp" :data="profileUser.clients_details" :currentIds="currentEpClientIds" />
        <div slot="modalFooter">
          <modal-footer :closeModal="close" :confirm="confirm" cancelText="Close" confirmText="Save"/>
        </div>
    </modal>
</template>

<script>
import Modal from '@/components/Modal/modal'
import ModalHeader from '@/components/Modal/modal-header'
import ModalFooter from '@/components/Modal/modal-footer'
import ButtonCta from '@/components/Button/button'
import {clientMixin} from '@/mixins/clientMixin'
import {notificationMixin} from '@/mixins/notificationMixin'
import ClientForm from '@/components/ClientForm/client-form'
import {modalMixin} from '@/mixins/modalMixin'
import List from '@/components/List/list'
import {profileMixin} from '@/mixins/profileMixin'
import {encodingProfileMixin} from '@/mixins/encodingProfileMixin'

export default {
  name: 'modal_assign_encoding_profile_to_client',
  mixins: [clientMixin, notificationMixin, modalMixin, encodingProfileMixin, profileMixin],
  components: {
    Modal,
    ModalHeader,
    ModalFooter,
    ButtonCta,
    ClientForm,
    List
  },
  props: {
    show: Boolean,
    id: String,
    name: String
  },
  data: () => ({
    clientsInEp: [],
    currentEpClientIds: []
  }),
  watch: {
    show () {
      if (this.show) {
        let currentEp = this.encodingProfiles.find((ep) => parseInt(ep.id) === parseInt(this.id))
        currentEp.clients.forEach((c) => {
          this.currentEpClientIds.push(c.hash_id)
        })
        this.clientsInEp = this.currentEpClientIds
      } else {
        this.currentEpClientIds = []
        this.clientsInEp = []
      }
    }
  },
  methods: {
    confirm () {
      this.startLoading()
      let payload = {
        'id': this.id,
        'clients': this.clientsInEp
      }
      this.assignEncodingProfile(payload).then(() => {
        this.getEncodingProfiles().then(() => {
          this.addNotification('success', `Encoding Profiles Assigned to Clients successfully`)
          this.finishLoading()
        })
      }, error => {
        this.finishLoading()
        this.addNotification('danger', error)
      })
      this.close()
    }
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/Modal/encoding-profile/modal-assign-encoding-profile-to-clients.vue